import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=22adff8d&scoped=true&"
var script = {}
import style0 from "./Tour.vue?vue&type=style&index=0&id=22adff8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22adff8d",
  null
  
)

export default component.exports